import React from 'react';
import { Select, Form } from 'antd';
import filterConnect from '../../../../common/hoc/filterConnect';
const Option = Select.Option;

// todo onChange={onChangeDaysOfWeeksOrder}  value={filter.dayOfWeeks}
const WeekDays = ({ form, weekDays }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Дни недели:">
      {getFieldDecorator('weekDays')(
        <Select
          style={{ width: '100%' }}
          className="ui-select"
          placeholder="Выберите день недели"
          allowClear={true}
          mode="multiple"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {weekDays &&
            weekDays.map(day => (
              <Option key={day.dayOfWeekKey} value={day.dayOfWeekKey}>
                {day.dayOfWeek}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default filterConnect(WeekDays, ['weekDays']);
